import _ from 'lodash';

export const selectModalData = modalName => state => {
  return _.get(state.modal, `${modalName}.data`, {});
};

export const selectAllOpenModals = () => state => {
  return _.pickBy(state.modal, x => _.get(x, 'isOpen', false));
};
